import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-edfd5d3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cubes me-2" }),
    /*#__PURE__*/_createTextVNode("ผลการดำเนินการโครงการในระดับเขตตรวจราชการ")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "แสดงรายละเอียดผลการดำเนินการโครงการในระดับเขตตรวจราชการ")
], -1))
const _hoisted_3 = { class: "card-body my-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectRegionSummaryComponent = _resolveComponent("ProjectRegionSummaryComponent")!
  const _component_RegionFilterComponent = _resolveComponent("RegionFilterComponent")!
  const _component_ResultProjectTypeComponent = _resolveComponent("ResultProjectTypeComponent")!
  const _component_ResultResponseComponent = _resolveComponent("ResultResponseComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_RegionFilterComponent, { onChange: _ctx.filterChange }, {
        default: _withCtx(() => [
          _createVNode(_component_ProjectRegionSummaryComponent, {
            "fiscal-year": _ctx.fiscalYear,
            region: _ctx.region,
            "is-file": true
          }, null, 8, ["fiscal-year", "region"])
        ]),
        _: 1
      }, 8, ["onChange"]),
      (_ctx.region)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_ResultProjectTypeComponent, {
              "fiscal-year": _ctx.fiscalYear,
              mode: "REGION",
              target: _ctx.region
            }, null, 8, ["fiscal-year", "target"]),
            _createVNode(_component_ResultResponseComponent, {
              "fiscal-year": _ctx.fiscalYear,
              mode: "REGION",
              "target-id": _ctx.region.id
            }, null, 8, ["fiscal-year", "target-id"])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}